/**
 * RequestStageService
 * Service for RequestStage entity operations
 * Route: api/requeststage
 * Controller: RequestStageController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestStageService
 * Handles request stage CRUD operations
 * Maps to /api/requeststage endpoint
 */
export class RequestStageService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestStageService.DEFAULT_SERVICE_PATH,
            basePath: RequestStageService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestStageService.DEFAULT_SERVICE_PATH = 'procurements';
RequestStageService.BASE_PATH = 'api/requeststage';
//# sourceMappingURL=RequestStageService.js.map